// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--bg);
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 40px;
  display: flex;
  align-items: center;
}

.header-left {
  flex: 1 1;
  display: flex;
  align-items: center;
}

.header-right {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.header-spacer {
  display: none;
}

.nav {
  display: flex;
  align-items: center;
  gap: 32px;
}

.nav-link {
  font-family: var(--font-body);
  color: var(--dark);
  font-size: 18px;
  font-weight: 400;
  transition: color 0.3s ease;
  position: relative;
  background: none;
}

.nav-link:hover {
  color: var(--gold);
}

.header-cart-icon {
  display: flex;
  position: relative;
  color: var(--dark);
  transition: color 0.3s ease;
}

.header-cart-icon:hover {
  color: var(--gold);
}

.header-cart-badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background-color: var(--gold);
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 1px 5px;
  border-radius: 10px;
  min-width: 16px;
  text-align: center;
}

.header-logo {
  width: 64px;
  height: 64px;
  flex-shrink: 0;
}

.header-logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logout-btn {
  padding: 0;
  font-size: 18px;
  font-weight: 400;
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 201;
  position: relative;
}

.hamburger span {
  display: block;
  width: 24px;
  height: 2px;
  background-color: var(--dark);
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.hamburger.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.hamburger.open span:nth-child(2) {
  opacity: 0;
}

.hamburger.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.nav-overlay {
  display: none;
}

@media (max-width: 768px) {
  .header-container {
    padding: 16px 20px;
  }

  .header-logo {
    width: 48px;
    height: 48px;
  }

  .header-right {
    gap: 16px;
  }

  .hamburger {
    display: flex;
  }

  .nav {
    position: fixed;
    top: 0;
    right: -280px;
    width: 280px;
    height: 100vh;
    background-color: var(--bg);
    flex-direction: column;
    align-items: flex-start;
    padding: 80px 32px 32px;
    gap: 8px;
    transition: right 0.3s ease;
    z-index: 200;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  }

  .nav-open {
    right: 0;
  }

  .nav-link {
    font-size: 20px;
    padding: 12px 0;
    width: 100%;
  }

  .nav-overlay {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 199;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,MAAM;IACN,aAAa;IACb,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;IAC3B,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,YAAY;EACd;AACF","sourcesContent":[".header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background-color: var(--bg);\n}\n\n.header-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 24px 40px;\n  display: flex;\n  align-items: center;\n}\n\n.header-left {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n\n.header-right {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.header-spacer {\n  display: none;\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.nav-link {\n  font-family: var(--font-body);\n  color: var(--dark);\n  font-size: 18px;\n  font-weight: 400;\n  transition: color 0.3s ease;\n  position: relative;\n  background: none;\n}\n\n.nav-link:hover {\n  color: var(--gold);\n}\n\n.header-cart-icon {\n  display: flex;\n  position: relative;\n  color: var(--dark);\n  transition: color 0.3s ease;\n}\n\n.header-cart-icon:hover {\n  color: var(--gold);\n}\n\n.header-cart-badge {\n  position: absolute;\n  top: -6px;\n  right: -10px;\n  background-color: var(--gold);\n  color: white;\n  font-size: 10px;\n  font-weight: bold;\n  padding: 1px 5px;\n  border-radius: 10px;\n  min-width: 16px;\n  text-align: center;\n}\n\n.header-logo {\n  width: 64px;\n  height: 64px;\n  flex-shrink: 0;\n}\n\n.header-logo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.logout-btn {\n  padding: 0;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.hamburger {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  gap: 5px;\n  width: 32px;\n  height: 32px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  z-index: 201;\n  position: relative;\n}\n\n.hamburger span {\n  display: block;\n  width: 24px;\n  height: 2px;\n  background-color: var(--dark);\n  border-radius: 2px;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.hamburger.open span:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.hamburger.open span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.open span:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n.nav-overlay {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .header-container {\n    padding: 16px 20px;\n  }\n\n  .header-logo {\n    width: 48px;\n    height: 48px;\n  }\n\n  .header-right {\n    gap: 16px;\n  }\n\n  .hamburger {\n    display: flex;\n  }\n\n  .nav {\n    position: fixed;\n    top: 0;\n    right: -280px;\n    width: 280px;\n    height: 100vh;\n    background-color: var(--bg);\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 80px 32px 32px;\n    gap: 8px;\n    transition: right 0.3s ease;\n    z-index: 200;\n    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);\n  }\n\n  .nav-open {\n    right: 0;\n  }\n\n  .nav-link {\n    font-size: 20px;\n    padding: 12px 0;\n    width: 100%;\n  }\n\n  .nav-overlay {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.4);\n    z-index: 199;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
